import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";

const styles = (theme) => ({
  FormControl: {
    width: "100%",
    marginBottom: "8px",
    marginTop: "8px",
  },

  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
function SelectRegis(props) {
  return (
    <FormControl component="fieldset" className={props.classes.FormControl}>
      <FormLabel component="legend">Operaciones</FormLabel>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={props.mean}
              onChange={(e) => {
                props.sentoParent("mean", !props.mean);
              }}
            />
          }
          label="Promedio"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={props.mode}
              onChange={(e) => {
                props.sentoParent("mode", !props.mode);
              }}
            />
          }
          label="Moda"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={props.stdDeviation}
              onChange={(e) => {
                props.sentoParent("stdDeviation", !props.stdDeviation);
              }}
            />
          }
          label="Desviación Estándar"
        />
      </FormGroup>
    </FormControl>
  );
}

export default withStyles(styles)(SelectRegis);
